import Separator from 'components/Separator'
import DarkTabMenuItem from 'components/Tabs/DarkTabMenuItem'
import RoundedTabMenu from 'components/Tabs/RoundedTabMenu'
import styled from 'styled-components'
import { fontSize, screenWidth } from 'utils'
import { color } from 'utils/styledHelper'

export const ModalCard = styled.div`
  min-width: 32rem;
  height: 40rem;
  padding: 2.5rem;
  background-color: ${color('dark800')};
  color: ${color('white')};

  @media only screen and (max-width: ${screenWidth('sm')}) {
    min-width: 100%;
    padding: 2.5rem 1rem;
  }
`

export const BodyTitle = styled.div`
  margin-bottom: 1.5rem;
`

export const Wrapper = ModalCard

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1.5rem;

  svg {
    margin-right: 1rem;
    cursor: pointer;
  }
`

export const ModalTitle = styled.h1`
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
  margin: 0;
  color: ${color('white')};
`

export const SelectMethodButton = styled.div<{ hasError?: boolean }>`
  padding: 1.5rem;
  margin-top: 1rem;
  border: 1px solid ${(p) => (p.hasError ?? false ? color('error') : color('dark500'))};
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  overflow-x: hidden;

  :hover {
    background: ${color('dark900')};
  }

  :active {
    background: ${color('grey900')};
  }

  svg:first-child,
  img:first-child {
    margin-right: 1.5rem;
  }

  span {
    flex: 1;
  }
`

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`

export const OptionTitle = styled.span`
  font-weight: 600;
  font-size: 1rem;
  line-height: 150%;
  color: ${color('white')};
  margin: 0;
`

export const OptionBody = styled.span`
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 150%;
  color: ${color('dark')};
  text-transform: capitalize;
  max-width: 22rem;
  word-break: break-word;
`

export const BigOptionBody = styled(OptionBody)`
  font-size: 0.875rem;
  max-width: 22rem;
  word-break: break-word;
`

export const ModalContainer = styled.div`
  margin-top: 56px;
`

export const StyledRoundedTabMenu = styled(RoundedTabMenu)`
  max-width: 100%;

  div {
    width: 100%;
  }
`

export const StyledDarkTabMenuItem = styled(DarkTabMenuItem)`
  height: 2rem;
  text-align: center;
  font-size: ${fontSize('sm')};
  text-transform: capitalize;
  padding: 0;
  line-height: 2rem;
`

export const StyledSeparator = styled(Separator)`
  min-width: 32rem;
  left: 0;
  position: absolute;
`
